import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class EvaluationService {

  key: string = 'evaluation'

  constructor(public hs: HttpService, public gs: GlobalService) { }
  
  async request_re_evaluation(value: any) {
    try {
      let response = await this.hs.post(`/${this.key}/request-re-evaluation`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async add(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post(`/${this.key}/add-${this.key}`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async start_head_evaluation(value: any) {
    try {
      let response = await this.hs.post(`/${this.key}/start-head-evaluation`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async draft(value: any) {
    try {
      delete value.id;
      let response = await this.hs.post(`/${this.key}/save-as-draft`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async delete(id: number) {
    try {
      let response = await this.hs.delete(`/${this.key}/delete-${this.key}?id=` + id, {})
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async get(id: any) {
    try {
      let response = await this.hs.get(`/${this.key}/get-${this.key}?${this.key}_id=` + id, {})
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async get_my_evaluation(filter: any) {
    try {
      let response = await this.hs.get(`/${this.key}/get-my-${this.key}`, filter)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async start_ramdom_evaluation(value: any) {
    try {
      let response = await this.hs.post(`/${this.key}/start-random-${this.key}`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async get_list(filters: any) {
    try {
      let response = await this.hs.get(`/${this.key}/get-${this.key}-list`, filters)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
  
  async submit(value: any) {
    try {
      let response = await this.hs.post(`/${this.key}/update-${this.key}`, {}, value)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async get_re_evaluation_list(filters: any) {
    try {
      let response = await this.hs.get(`/${this.key}/get-re-evaluation-list`, filters)
      return response;
    } catch (error: any) {
      throw error;
    }
  }

}
